import { render, staticRenderFns } from "./activeGradeStatis.vue?vue&type=template&id=2b455c8f&scoped=true"
import script from "./activeGradeStatis.vue?vue&type=script&lang=js"
export * from "./activeGradeStatis.vue?vue&type=script&lang=js"
import style0 from "./activeGradeStatis.vue?vue&type=style&index=0&id=2b455c8f&prod&lang=scss&scoped=true"
import style1 from "./activeGradeStatis.vue?vue&type=style&index=1&id=2b455c8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b455c8f",
  null
  
)

export default component.exports